import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useSaveLastUsedPath = () => {
  const searchParams = useSelector(select.location.getQuery);
  const redirectorTag = searchParams?.['redirector-tag'];

  const setUrlPath = useCallback(
    (path: string) => {
      if (!redirectorTag) return;

      window.starsweb?.setUrlPath?.(redirectorTag, encodeURIComponent(path));
    },
    [redirectorTag]
  );

  return setUrlPath;
};

export default useSaveLastUsedPath;
